import React from "react";
import PropTypes from "prop-types";

function ProductImage({ imageSize, imageUrl, imageAltText }) {
    const height = imageSize === "LARGE" ? 250 : 156;
    const width = imageSize === "LARGE" ? 200 : 125;

    return (
        <img
            className="product-card__image"
            src={imageUrl}
            height={height}
            width={width}
            alt={imageAltText}
            data-pin-no-hover="true"
        />
    );
}

export default ProductImage;

ProductImage.propTypes = {
    imageSize: PropTypes.string.isRequired,
    imageUrl: PropTypes.string.isRequired,
    imageAltText: PropTypes.string
};

ProductImage.defaultProps = {
    imageAltText: ""
};
